import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('quote_rates', '/plans/quote_rates', 'quote_rates')
const actions = generator.generate()

export default actions
